"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHostContentShareObserver = createHostContentShareObserver;
exports.createSpeakerContentShareObserver = createSpeakerContentShareObserver;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../constants/logger");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function createHostContentShareObserver(dispatch, createScreenShareSource, meetingResponse, attendeeResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  return {
    contentShareDidStart: function contentShareDidStart() {
      dispatch(createScreenShareSource());
      var logPayload = {
        chimeEventName: 'contentShareDidStart',
        'studio.meeting.id': meetingId,
        title: "Screen share process started by attendee ".concat(attendeeId, " from meeting id: ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    },
    contentShareDidStop: function contentShareDidStop() {
      var logPayload = {
        chimeEventName: 'contentShareDidStop',
        'studio.meeting.id': meetingId,
        title: "Screen share process stopped by attendee ".concat(attendeeId, " from meeting id: ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    },
    contentShareDidPause: function contentShareDidPause() {
      var logPayload = {
        chimeEventName: 'contentShareDidPause',
        'studio.meeting.id': meetingId,
        title: "Screen share paused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    },
    contentShareDidUnpause: function contentShareDidUnpause() {
      var logPayload = {
        chimeEventName: 'contentShareDidUnpause',
        'studio.meeting.id': meetingId,
        title: "Screen share unpaused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    }
  };
}
function createSpeakerContentShareObserver(dispatch, setScreenShareActive, meetingResponse, attendeeResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  return {
    contentShareDidStart: function contentShareDidStart() {
      var logPayload = {
        chimeEventName: 'contentShareDidStart',
        'studio.meeting.id': meetingId,
        title: "Content share started for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
      dispatch(setScreenShareActive(true));
    },
    contentShareDidStop: function contentShareDidStop() {
      var logPayload = {
        chimeEventName: 'contentShareDidStop',
        'studio.meeting.id': meetingId,
        title: "Content share stopped for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
      dispatch(setScreenShareActive(false));
    },
    contentShareDidPause: function contentShareDidPause() {
      var logPayload = {
        chimeEventName: 'contentShareDidPause',
        'studio.meeting.id': meetingId,
        title: "Content share paused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    },
    contentShareDidUnpause: function contentShareDidUnpause() {
      var logPayload = {
        chimeEventName: 'contentShareDidUnpause',
        'studio.meeting.id': meetingId,
        title: "Content share unpaused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      logger.info(logPayload.title, logPayload);
    }
  };
}